const allEntriesExist = function (searchInArray, searchForArray) {
  if (!searchForArray || searchForArray.length === 0) {
    return true
  }

  if (!searchInArray || searchInArray.length === 0) {
    return false
  }

  let retValue = true
  searchForArray.forEach((role) => {
    if (!searchInArray.includes(role)) {
      retValue = false
    }
  })

  return retValue
}

const atLeastOneExists = function (searchInArray, searchForArray) {
  if (!searchForArray || searchForArray.length === 0) {
    return true
  }

  if (!searchInArray || searchInArray === 0) {
    return false
  }

  let retValue = false
  searchForArray.forEach((role) => {
    if (searchInArray.includes(role)) {
      retValue = true
    }
  })

  return retValue
}

const buildAndNavigateToScanToVasionUrl = async function (actionString) {
  const scanToVasionBaseUrl = process.env.VUE_APP_SCANTOVASION_BASE
  const apiUrl = `${process.env.VUE_APP_PROTOCOL}://${process.env.VUE_APP_API}`
  window.open(
    `${scanToVasionBaseUrl}${encodeURIComponent(apiUrl)}~${actionString}`,
    '_blank',
  )
}

const getDateTimeDisplayValue = (dateString) => {
  if (!isNaN(Date.parse(dateString))) {
    const date = new Date(dateString)
    const locale = navigator.language
    const options = { dateStyle: "short", timeStyle: "medium" }
    return date.toLocaleString(locale, options)
  }
  return ''
}

const getToken = function (token) {
  return token || localStorage.getItem('UserToken')
}

const isIPad = () => {
  if (/iPad/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 0) || navigator.platform === 'iPad') {
    return true
  }
  return false
}

const isSafari = () => {
  // Chrome in iPad
  if(navigator.userAgent.match('CriOS')) return false
  // Safari
  if (navigator.userAgent.search("Safari") >= 0 && navigator.userAgent.search("Chrome") < 0) return true
  // Others
  return false
}

const isMobileSize = () => {
  if (screen.width <= 768) {
    return true;
  }
  else {
    return false;
  }
}

const isValidURL = (str) => {
  const pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
    '((([a-z\\d]+(-[a-z\\d]+)*)\\.)+[a-z]{2,}|' + // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
    '(\\?[{};&a-z\\d%_.~+=-]*)?' + // query string
    '(\\#[-a-z\\d_]*)?$', 'i') // fragment locator
  return !!pattern.test(str)
}

const openUrlInNewBrowserWindow = (url) => {
  const screenWidth = screen.width;
  const screenHeight = screen.height;
  const newWidth = Math.min(screenWidth * 0.8, 1200);
  const newHeight = Math.min(screenHeight * 0.8, 800);

  var newWindow = window.open(url, "_blank", `width=${newWidth},height=${newHeight}`);

  if (newWindow) {
      newWindow.focus();
  } else {
      alert('Please allow popups for this site and try again.');
  }
}

const removeIllegalChars = async function (value) {
  return value.replace(/[<>:"/\\|?*]/g, '')
}

/**
 * Sorts table data and allows you to transform elements to sort on,
 * so you can sort using keys as deep as you want in each iterated object.
 */
const tableSorterWithTransform = function (elementTransform, sortTableAscending) {
  return function (a, b) {
    const item1 = elementTransform(a)
    const item2 = elementTransform(b)

    if (sortTableAscending) {
      return typeof item1 === 'string'
        ? `${(item1).localeCompare(item2)}`
        : item1 - item2
    } else {
      return typeof item1 === 'string'
        ? `${(item2).localeCompare(item1)}`
        : item2 - item1
    }
  }
}

/**
 * Sorts table data.
 *
 * @deprecated by tableSorterWithTransform
 */
const tableSorter = function (sortTableBy, sortTableAscending) {
  return function (a, b) {
    const item1 = a[sortTableBy]
    const item2 = b[sortTableBy]

    if (sortTableAscending) {
      return typeof item1 === 'string'
        ? `${(item1).localeCompare(item2)}`
        : item1 - item2
    } else {
      return typeof item1 === 'string'
        ? `${(item2).localeCompare(item1)}`
        : item2 - item1
    }
  }
}

const testDownloadHasFileExtension = async function (downloadResult, fileName, testFileExtension) {
  // eslint-disable-next-line
  const fileDownload = require('js-file-download')

  if (fileName.endsWith(testFileExtension)) {
    fileDownload(downloadResult, `${fileName}`)
  } else {
    fileDownload(downloadResult, `${fileName}${testFileExtension}`)
  }
}

const testIsGuid = async function (value) {
  if (value === null) {
    return false
  }

  const test = value.toString().match(/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/)
  return test !== null
}

export {
  allEntriesExist,
  atLeastOneExists,
  buildAndNavigateToScanToVasionUrl,
  getDateTimeDisplayValue,
  getToken,
  isIPad,
  isSafari,
  isMobileSize,
  isValidURL,
  openUrlInNewBrowserWindow,
  removeIllegalChars,
  tableSorter,
  tableSorterWithTransform,
  testDownloadHasFileExtension,
  testIsGuid,
}
